import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { SharedFormPipesModule } from '@sondermind/iris/form-helpers';
import { IrisIconModule } from '@sondermind/iris/icon';

import { IrisRadioGroupComponent } from './radio-group.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    IrisIconModule,
    SharedFormPipesModule
  ],
  declarations: [
    IrisRadioGroupComponent
  ],
  exports: [
    IrisRadioGroupComponent
  ]
})

export class IrisRadioGroupModule {}
